module.exports = __webpack_public_path__ + "static/media/multicanal.c9ff82cf.svg";